import { useQuery } from '@apollo/client';
import { GET_MERCHANT_KEYS, GET_MERCHANT_PROFILE } from '../graphql/queries';

const useMerchantProfile = (id, keys = false) => {
    const query = keys ? GET_MERCHANT_KEYS : GET_MERCHANT_PROFILE;
    return useQuery(query, { variables: { user_id: id } });

};

export default useMerchantProfile;
